import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MasterMenuSelectors } from '@emm/management/store/mms-revote/master-menu-system.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {Revotes} from '@emm/core/models/revotes.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {MasterMenuSystemActions} from '@emm/management/store/mms-revote/master-menu-system.actions';
import {SearchFilter} from '@emm/core/models/search-filter';


export interface MasterMenuQueries extends AsyncActionQueries {
  all$: Observable<any[]>;
  selectedRevote$: Observable<Revotes>;
  categories$: Observable<any>;
  selectedCategories$: Observable<any>;
  locations$: Observable<any>;
  selectedLocations$: Observable<any>;
}

@Injectable({
  providedIn: 'root',
})
export class MasterMenuSystemStoreService extends AsyncActionStoreService<AsyncActionSelectors> {
  constructor(store: Store<CoreState>) {
    super(store, MasterMenuSelectors);
  }

  dispatch = {
    openAddRevoteDialog: () => this.store.dispatch(MasterMenuSystemActions.openAddDialog()),
    selectRevote: (revote) => this.store.dispatch(MasterMenuSystemActions.select({revote})),
    searchRevote: (filter: SearchFilter) => this.store.dispatch(MasterMenuSystemActions.searchRevote({filter})),
    deleteRevote: (revote) => this.store.dispatch(MasterMenuSystemActions.delete({ revote })),
    updateCategories: (consumer) => this.store.dispatch(MasterMenuSystemActions.loadAllCategories({ consumer })),
    updateLocations: (consumer) => this.store.dispatch(MasterMenuSystemActions.loadAllLocations({ consumer })),
  };

  queries: MasterMenuQueries = {
    all$: this.selectNonNil(MasterMenuSelectors.getFilteredRevotes),
    categories$: this.selectNonNil(MasterMenuSelectors.getAllCategories),
    selectedCategories$: this.selectNonNil(MasterMenuSelectors.getSelected),
    locations$: this.selectNonNil(MasterMenuSelectors.getAllLocations),
    selectedRevote$: this.selectNonNil(MasterMenuSelectors.getSelected),
    selectedLocations$: this.selectNonNil(MasterMenuSelectors.getSelected),
    ...this.asyncActionQueries,
  };
}
